import { render, staticRenderFns } from "./create-campaign-modal.vue?vue&type=template&id=40069c1c"
import script from "./create-campaign-modal.vue?vue&type=script&lang=js"
export * from "./create-campaign-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports